import { takeLatest, put, call } from 'redux-saga/effects';

import { findBaixaManualEstoque } from '../service';
import {
  FIND_BAIXAR_MANUAL_ESTOQUE,
  FIND_BAIXAR_MANUAL_ESTOQUE_PENDING,
  FIND_BAIXAR_MANUAL_ESTOQUE_SUCCESS,
  FIND_BAIXAR_MANUAL_ESTOQUE_FAILURE
} from '../actionTypes';

function* sagaFindBaixaManualEstoque(action) {
  yield put({ type: FIND_BAIXAR_MANUAL_ESTOQUE_PENDING, id: action.id })

  try {

    const registro = yield call(findBaixaManualEstoque, action.id);

    yield put({ type: FIND_BAIXAR_MANUAL_ESTOQUE_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_BAIXAR_MANUAL_ESTOQUE_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindBaixaManualEstoque() {
  yield takeLatest(FIND_BAIXAR_MANUAL_ESTOQUE, sagaFindBaixaManualEstoque)
}
